/**
 * Created by Shiv Roy on 23/11/17.
 */
import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  extractNameFromArray,
  jsonApiHeader,
  showSuccessMessage,
  showErrorMessage,
} from '../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  extractDataFromObject,
  extractNameFromArray,
  API_URL,
  showErrorMessage,
};

export const GET_APP_CONFIG_API = `${API_URL}/AppConfigurations/GetAppConfigurations`;
export const POST_APP_CONFIG_API = `${API_URL}/AppConfigurations/UpdateAppConfiguration`;
export const IF_RECORD_EXIST= `${API_URL}/CheckIfRecordExists`;
export const IF_RECORD_EXIST_MASTERDB= `${API_URL}/CheckIfRecordExistsMasterDB`;


export const appConfigActionTypes = {
  get_app_config: createRequestActionTypes('GET_APP_CONFIG'),
  field_exist_error: createRequestActionTypes('FIELD_EXIST_ERROR'),
  clear_field_exist_error: createRequestActionTypes('CLEAR_FIELD_EXIST_ERROR'),
  post_app_config: createRequestActionTypes('POST_APP_CONFIG'),
  update_active_status: createRequestActionTypes('UPDATE_ACTIVE_STATUS'),
  get_GEO_Location: createRequestActionTypes('GET_GEO_LOCATION'),
  get_GEO_Location_ClockIn: createRequestActionTypes('GET_GEO_LOCATION_CLOCKIN'),
  get_GEO_Location_ClockOut: createRequestActionTypes('GET_GEO_LOCATION_CLOCKOUT'),
};




// WEBPACK FOOTER //
// ./src/modules/AppConfig/constants/index.js